import React from "react";
import Header from "components/v3/header/Header";
import { validateEmail } from "common/utils/Validation";
import styles from "./styles.module.scss";

const EmailResent = ({ email }) => {
    // [LW] if email is incorrectly formatted, don't show the page, to prevent text-injection attacks
    if (validateEmail(email)) {
        return null;
    }

    return (
        <div>
            <Header title="Email resent" />
            <div className={ styles.text }>
                We have resent an email to { email }.
                Please click on the link in the email to set your password.
            </div>
        </div>
    );
};

export default EmailResent;
